import { Calendar, MessageCircle, Book } from "lucide-react";

interface BottomNavProps {
  onCTAClick?: () => void;
  onSermonClick?: () => void;
}

export function BottomNav({ onCTAClick, onSermonClick }: BottomNavProps) {

  const handleInquire = () => {
    window.open("https://www.instagram.com/jcministry_/", "_blank");
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-card/95 dark:bg-background/95 backdrop-blur-md border-t border-border z-40 pb-safe">
      <div className="grid grid-cols-3 gap-1 px-2 py-3 max-w-lg mx-auto">
        {/* Attend Button */}
        <button
          onClick={onCTAClick}
          className="flex flex-col items-center justify-center py-2 px-1 rounded-lg active:bg-muted transition-colors group hover-lift"
        >
          <div className="bg-primary/10 dark:bg-primary/20 p-2 rounded-full mb-1 group-hover:bg-primary/20 transition-colors">
            <Calendar className="text-primary w-5 h-5" />
          </div>
          <span className="text-xs font-bold text-card-foreground">참석하기</span>
          <span className="text-[10px] text-muted-foreground font-light">Attend</span>
        </button>

        {/* Inquire Button */}
        <button
          onClick={handleInquire}
          className="flex flex-col items-center justify-center py-2 px-1 rounded-lg active:bg-muted transition-colors group hover-lift"
        >
          <div className="bg-primary/10 dark:bg-primary/20 p-2 rounded-full mb-1 group-hover:bg-primary/20 transition-colors">
            <MessageCircle className="text-primary w-5 h-5" />
          </div>
          <span className="text-xs font-bold text-card-foreground">문의하기</span>
          <span className="text-[10px] text-muted-foreground font-light">Inquire</span>
        </button>

        {/* Recent Worship Button */}
        <button
          onClick={onSermonClick}
          className="flex flex-col items-center justify-center py-2 px-1 rounded-lg active:bg-muted transition-colors group hover-lift"
        >
          <div className="bg-primary/10 dark:bg-primary/20 p-2 rounded-full mb-1 group-hover:bg-primary/20 transition-colors">
            <Book className="text-primary w-5 h-5" />
          </div>
          <span className="text-xs font-bold text-card-foreground">최근 예배</span>
          <span className="text-[10px] text-muted-foreground font-light">Worship</span>
        </button>
      </div>
    </div>
  );
}